import { OP, STATUS } from "../../constant";


const INITIAL_STATE = {
    // ------- staff initial-------- //
    staffListStatus: STATUS.DEFAULT,
    staffListResult: null,
    staffListErrorMessage: '',

    addStaffStatus: STATUS.DEFAULT,
    addStaffResult: null,
    addStaffErrorMessage: '',

    viewStaffStatus: STATUS.DEFAULT,
    viewStaffResult: null,
    viewStaffErrorMessage: '',

    editStaffStatus: STATUS.DEFAULT,
    editStaffResult: null,
    editStaffErrorMessage: '',

    activateStaffStatus: STATUS.DEFAULT,
    activateStaffResult: null,
    activateStaffErrorMessage: '',

    deactivateStaffStatus: STATUS.DEFAULT,
    deactivateStaffResult: null,
    deactivateStaffErrorMessage: '',

    approveStaffStatus: STATUS.DEFAULT,
    approveStaffResult: null,
    approveStaffErrorMessage: '',

    rejectStaffStatus: STATUS.DEFAULT,
    rejectStaffResult: null,
    rejectStaffErrorMessage: '',

    resetStaffPasswordStatus: STATUS.DEFAULT,
    resetStaffPasswordResult: null,
    resetStaffPasswordErrorMessage: '',

    unblockStaffStatus: STATUS.DEFAULT,
    unblockStaffResult: null,
    unblockStaffErrorMessage: ''
}

export default (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
        // *------- > staff list reduces
        case OP.STAFF_LIST_LOADING:
            return {
                ...state,
                staffListStatus: STATUS.LOADING
            }
        case OP.STAFF_LIST_SUCCESS:
            return {
                ...state,
                staffListStatus: STATUS.SUCCESS,
                staffListResult: payload,
                staffListErrorMessage: ''
            }
        case OP.STAFF_LIST_FAILURE:
            return {
                ...state,
                staffListStatus: STATUS.ERROR,
                staffListResult: null,
                staffListErrorMessage: payload
            }
        case OP.STAFF_LIST_RESET:
            return {
                ...state,
                staffListStatus: STATUS.DEFAULT,
                staffListResult: null,
                staffListErrorMessage: ''
            }

        // *-------- > add staff reducers
        case OP.ADD_STAFF_LOADING:
            return {
                ...state,
                addStaffStatus: STATUS.LOADING
            }
        case OP.ADD_STAFF_SUCCESS:
            return {
                ...state,
                addStaffStatus: STATUS.SUCCESS,
                addStaffResult: payload,
                addStaffErrorMessage: ''
            }
        case OP.ADD_STAFF_FAILURE:
            return {
                ...state,
                addStaffStatus: STATUS.ERROR,
                addStaffResult: null,
                addStaffErrorMessage: payload
            }
        case OP.ADD_STAFF_RESET:
            return {
                ...state,
                addStaffStatus: STATUS.DEFAULT,
                addStaffResult: null,
                addStaffErrorMessage: ''
            }

        // *-------- > view staff reducers
        case OP.VIEW_STAFF_LOADING:
            return {
                ...state,
                viewStaffStatus: STATUS.LOADING
            }
        case OP.VIEW_STAFF_SUCCESS:
            return {
                ...state,
                viewStaffStatus: STATUS.SUCCESS,
                viewStaffResult: payload,
                viewStaffErrorMessage: ''
            }
        case OP.VIEW_STAFF_FAILURE:
            return {
                ...state,
                viewStaffStatus: STATUS.ERROR,
                viewStaffResult: null,
                viewStaffErrorMessage: payload
            }
        case OP.VIEW_STAFF_RESET:
            return {
                ...state,
                viewStaffStatus: STATUS.DEFAULT,
                viewStaffResult: null,
                viewStaffErrorMessage: ''
            }

        // *-------- > edit staff reducers
        case OP.EDIT_STAFF_LOADING:
            return {
                ...state,
                editStaffStatus: STATUS.LOADING
            }
        case OP.EDIT_STAFF_SUCCESS:
            return {
                ...state,
                editStaffStatus: STATUS.SUCCESS,
                editStaffResult: payload,
                editStaffErrorMessage: ''
            }
        case OP.EDIT_STAFF_FAILURE:
            return {
                ...state,
                editStaffStatus: STATUS.ERROR,
                editStaffResult: null,
                editStaffErrorMessage: payload
            }
        case OP.EDIT_STAFF_RESET:
            return {
                ...state,
                editStaffStatus: STATUS.DEFAULT,
                editStaffResult: null,
                editStaffErrorMessage: ''
            }

        // *-------- > activate staff reducers
        case OP.ACTIVATE_STAFF_LOADING:
            return {
                ...state,
                activateStaffStatus: STATUS.LOADING
            }
        case OP.ACTIVATE_STAFF_SUCCESS:
            return {
                ...state,
                activateStaffStatus: STATUS.SUCCESS,
                activateStaffResult: payload,
                activateStaffErrorMessage: ''
            }
        case OP.ACTIVATE_STAFF_FAILURE:
            return {
                ...state,
                activateStaffStatus: STATUS.ERROR,
                activateStaffResult: null,
                activateStaffErrorMessage: payload
            }
        case OP.ACTIVATE_STAFF_RESET:
            return {
                ...state,
                activateStaffStatus: STATUS.DEFAULT,
                activateStaffResult: null,
                activateStaffErrorMessage: ''
            }

        // *-------- > deactivate staff reducers
        case OP.DEACTIVATE_STAFF_LOADING:
            return {
                ...state,
                deactivateStaffStatus: STATUS.LOADING
            }
        case OP.DEACTIVATE_STAFF_SUCCESS:
            return {
                ...state,
                deactivateStaffStatus: STATUS.SUCCESS,
                deactivateStaffResult: payload,
                deactivateStaffErrorMessage: ''
            }
        case OP.DEACTIVATE_STAFF_FAILURE:
            return {
                ...state,
                deactivateStaffStatus: STATUS.ERROR,
                deactivateStaffResult: null,
                deactivateStaffErrorMessage: payload
            }
        case OP.DEACTIVATE_STAFF_RESET:
            return {
                ...state,
                deactivateStaffStatus: STATUS.DEFAULT,
                deactivateStaffResult: null,
                deactivateStaffErrorMessage: ''
            }


        // *-------- >approve Staff reducers
        case OP.APPROVE_STAFF_LOADING:
            return {
                ...state,
                approveStaffStatus: STATUS.LOADING
            }
        case OP.APPROVE_STAFF_SUCCESS:
            return {
                ...state,
                approveStaffStatus: STATUS.SUCCESS,
                approveStaffResult: payload,
                approveStaffErrorMessage: ''
            }
        case OP.APPROVE_STAFF_FAILURE:
            return {
                ...state,
                approveStaffStatus: STATUS.ERROR,
                approveStaffResult: null,
                approveStaffErrorMessage: payload
            }
        case OP.APPROVE_STAFF_RESET:
            return {
                ...state,
                approveStaffStatus: STATUS.DEFAULT,
                approveStaffResult: null,
                approveStaffErrorMessage: ''
            }

        // *-------- >reject Staff reducers
        case OP.REJECT_STAFF_LOADING:
            return {
                ...state,
                rejectStaffStatus: STATUS.LOADING
            }
        case OP.REJECT_STAFF_SUCCESS:
            return {
                ...state,
                rejectStaffStatus: STATUS.SUCCESS,
                rejectStaffResult: payload,
                rejectStaffErrorMessage: ''
            }
        case OP.REJECT_STAFF_FAILURE:
            return {
                ...state,
                rejectStaffStatus: STATUS.ERROR,
                rejectStaffResult: null,
                rejectStaffErrorMessage: payload
            }
        case OP.REJECT_STAFF_RESET:
            return {
                ...state,
                rejectStaffStatus: STATUS.DEFAULT,
                rejectStaffResult: null,
                rejectStaffErrorMessage: ''
            }

            // *-------- >reset Staff password reducers
        case OP.RESET_STAFF_PASSWORD_LOADING:
            return {
                ...state,
                resetStaffPasswordStatus: STATUS.LOADING
            }
        case OP.RESET_STAFF_PASSWORD_SUCCESS:
            return {
                ...state,
                resetStaffPasswordStatus: STATUS.SUCCESS,
                resetStaffPasswordResult: payload,
                resetStaffPasswordErrorMessage: ''
            }
        case OP.RESET_STAFF_PASSWORD_FAILURE:
            return {
                ...state,
                resetStaffPasswordStatus: STATUS.ERROR,
                resetStaffPasswordResult: null,
                resetStaffPasswordErrorMessage: payload
            }
        case OP.RESET_STAFF_PASSWORD_RESET:
            return {
                ...state,
                resetStaffPasswordStatus: STATUS.DEFAULT,
                resetStaffPasswordResult: null,
                resetStaffPasswordErrorMessage: ''
            }

        // *-------- >unblock Staff reducers
        case OP.UNBLOCK_STAFF_LOADING:
            return {
                ...state,
                unblockStaffStatus: STATUS.LOADING
            }
        case OP.UNBLOCK_STAFF_SUCCESS:
            return {
                ...state,
                unblockStaffStatus: STATUS.SUCCESS,
                unblockStaffResult: payload,
                unblockStaffErrorMessage: ''
            }
        case OP.UNBLOCK_STAFF_FAILURE:
            return {
                ...state,
                unblockStaffStatus: STATUS.ERROR,
                unblockStaffResult: null,
                unblockStaffErrorMessage: payload
            }
        case OP.UNBLOCK_STAFF_RESET:
            return {
                ...state,
                unblockStaffStatus: STATUS.DEFAULT,
                unblockStaffResult: null,
                unblockStaffErrorMessage: ''
            }


        default:
            return state

    }
}